let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eu7SV")).then(() => parcelRequire('4SXVP'));